import api from "src/apis/api"

export async function fetchDuesDashboard(filters = {}) {
  const params = new URLSearchParams()
  if (filters.project_id) params.set("project_id", filters.project_id)
  const { data } = await api.get(`/api/v1/collections/dashboard?${params}`)
  return data
}

export async function fetchAgingReport(filters = {}) {
  const params = new URLSearchParams()
  if (filters.project_id) params.set("project_id", filters.project_id)
  const { data } = await api.get(`/api/v1/collections/aging?${params}`)
  return data
}

export async function remindInstallment(installmentId, channel = "email") {
  const { data } = await api.post("/api/v1/collections/remind", {
    installment_id: installmentId,
    channel,
  })
  return data
}

export async function sendDemandLetter(bookingId, installmentId = null) {
  const payload = { booking_id: bookingId }
  if (installmentId) payload.installment_id = installmentId
  const { data } = await api.post("/api/v1/collections/demand_letter", payload)
  return data
}

export function receiptUrl(paymentId) {
  return `/api/v1/collections/receipt/${paymentId}`
}

export function agingExportUrl(filters = {}) {
  const params = new URLSearchParams()
  if (filters.project_id) params.set("project_id", filters.project_id)
  return `/api/v1/collections/export/aging?${params}`
}

export async function fetchReminderSettings() {
  const { data } = await api.get("/api/v1/collection_settings")
  return data.settings
}

export async function updateReminderSettings(settings) {
  const { data } = await api.patch("/api/v1/collection_settings", { settings })
  return data.settings
}
